import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarsLogicService } from './logic/cars/cars-logic.service';
import { CarsService } from './logic/cars.service';
import { CarsDaoService } from './dao/cars-dao.service';
import { CarsDbDaoService } from './dao/cars-dao/cars-db-dao.service';
import { CarDbTableDefinition } from './dao/cars-dao/car-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: CarsService, useClass: CarsLogicService },
    { provide: CarsDaoService, useClass: CarsDbDaoService },
    { provide: CarDbTableDefinition },
  ]
})
export class CarsModule {}
